import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import Chart from 'chart.js/auto';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { lastValueFrom } from 'rxjs';
import { WoundCareWidgetService } from '../../wound-care-widget.service';
import { calculateArea, calculateVolume } from '../../wound-utils';
import * as moment from 'moment';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { CensusListService } from 'src/app/includes/census-list/census-list..service';
import { AuthService } from 'src/app/services/auth.service';
import { PatientRoundingSheetService } from 'src/app/includes/patient-rounding-sheets/patient-rounding-sheet.service';
import _ from 'lodash';


@Component({
  selector: 'app-wound-care-widget-item-graph',
  templateUrl: './wound-care-widget-item-graph.component.html',
  styleUrls: ['./wound-care-widget-item-graph.component.css']
})
export class WoundCareWidgetItemGraphComponent implements OnInit, AfterViewInit {
  loaderId = 'app-wound-care-widget-item-graph';
  @Input() note;
  @Input() parentWoundId;
  @Input() readOnlyMode;
  wounds: {
    length: number,
    width: number,
    depth: number,
    createdAt: Date | string,
    updatedAt: Date | string,
    area: number | string,
    volume: number | string,
    source: string,
    entered_dot_phrases: any

  }[] = []
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
  /**
   {
      "_id": "61fbc932c17379780abc60f7",
      "parent_wound": "61fbc079cc0230734ecc5f27",
      "state": "active",
      "wound_images": [
          "https://doctornow-userfiles-mobilehub-211093030.s3.amazonaws.com/Wounds/Dev/6152e3c2c1d47c5f03780d8f/1643890985885.jpg"
      ],
      "wound_recognition_date": null,
      "wound_recognition_date_type": "",
      "extra_note": "no extra note",
      "created_by": {
          "_id": "5f67960644c89468ef27ad64",
          "first_name": "Test",
          "last_name": "Provider 1",
          "title": "P.A."
      },
      "facility_id": "607544e6c09f671af0612f67",
      "patient_id": "6152e3c2c1d47c5f03780d8f",
      "census_id": "61fbb4ba3da4196c5a67e767",
      "wound_location_image": "",
      "etiolgy": "",
      "body_part": null,
      "wound_type": null,
      "stage": null,
      "body_side": null,
      "length": "3",
      "width": "2",
      "depth": "1",
      "under_mining": true,
      "undermining_to": "7",
      "undermining_from": "6",
      "undermining_distance": "12",
      "tunneling": false,
      "tunneling_direction": "9",
      "tunneling_distance": "36",
      "exudate": "Moderate",
      "color": "Pink",
      "odor": "Mild",
      "pain": "4",
      "woundNo": 1,
      "createdAt": "2022-02-03T12:23:14.308Z",
      "updatedAt": "2022-02-10T12:07:28.539Z",
      "__v": 0
  }
   */
  canvas: any;
  ctx: any;
  @ViewChild('lineChart') lineChart: any;
  chart: any;
  carryOverCharge: any;
  charge: any;
  carryChargeStatus: boolean;
  currentUser: any;
  allDataLoaded: Boolean = false;

  constructor(private _woundCareWidgetService: WoundCareWidgetService,
    private loader: NgxUiLoaderService,
    private _company: CompanyService,
    private censusListService: CensusListService,
    private authService: AuthService,
    private service: PatientRoundingSheetService
  ) {
    this.currentUser = this.authService.currentUser;
    this.loaderId = this.parentWoundId;
  }
  async ngAfterViewInit() {
    // this.carryChargeStatus = await this._company.checkCompanyPermission("charges_carry_forward", this.currentUser.company_id);
    // await this.initCharge();
  }
  ngOnDestroy() {
    console.log("Check Charts");
    if(this.chart){
      console.log("Destroy Chart");
      this.chart.destroy();
    }
  }
  async ngOnInit(){
    console.log(this.parentWoundId);
    await this.initWounds();
    this.createGraph();
    this.loader.stopLoader(this.loaderId)
  }
  async initCharge() {
    const details = {
      patient_id: this.note.patient._id,
      rounding_sheet_id: this.note.rounding_sheet_id,
      visit_date: this.note.dates.service,
      status: null
    }
    let response: any = await this.censusListService.getCharge(details).toPromise();
    if (response.status === 200) {
      this.charge = response.data;
      if (!this.charge && this.carryChargeStatus) {
        let res: any = await this.service.getRecentCharge(details).toPromise()
        if (res.status == 200) {
          this.carryOverCharge = res.data;
          this.charge = this.carryOverCharge;
        }
      }
    }
  }

  async initWounds() {
    this.loader.startLoader(this.loaderId)
    const { status, data } = await lastValueFrom(this._woundCareWidgetService.getWoundGraphData(this.parentWoundId)) as any;
    if (status == 200) {
      this.wounds = data.array.map(item => ({
        length: parseFloat(item.length.toString()),
        width: parseFloat(item.width.toString()),
        depth: parseFloat(item.depth.toString()),
        createdAt: new Date(item.createdAt),
        updatedAt: new Date(item.updatedAt),
        area: item?.area,
        volume: parseFloat(item?.area) * item?.depth,
        source: item.source,
        entered_dot_phrases: item?.entered_dot_phrases
      }));
    }
  }

  createGraph() {
    // let charge_phrase = this.charge.cpt_modifiers.map((charge) => {'key': charge.key[charge.key.length - 1], enter_date: enter_date.month + "/" + enter_date.day + "/" + enter_date.year})
    const charge_phrase = []
    let MONTHS = { Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6, Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12 };
    let enteredDotphrases = JSON.parse(JSON.stringify(this.wounds[0].entered_dot_phrases));
    enteredDotphrases.forEach((ele)=>{
        if(ele.enter_date){
          if(ele.enter_date.day < 10){
            charge_phrase.push({
              key: ele.key,
              enter_date: this.months[ele.enter_date.month - 1] + "/" +"0"+ ele.enter_date.day + "/" + ele.enter_date.year
            })
          }else{
            charge_phrase.push({
              key: ele.key,
              enter_date: this.months[ele.enter_date.month - 1] + "/" + ele.enter_date.day + "/" + ele.enter_date.year
            })
          }
        }
      });
    let area = JSON.parse(JSON.stringify(this.wounds.map(calculateArea)));
    area.forEach((ar,index)=>{
      if(area.length > 1){
        if(ar <= 0 && (index === area.length - 1)){
          area[index] = null
        } 
      }else{
        if(ar <= 0){
          area[index] = null
        }
      }
    });
    let volume = JSON.parse(JSON.stringify(this.wounds.map(calculateVolume)));
    volume.forEach((vol,index)=>{
      if(volume.length > 1){
        if(vol <= 0 && (index === volume.length - 1) && area[index] === null){
          volume[index] = null
        }
      }else{
        if(vol <= 0 && area[index] === null){
          volume[index] = null
        }
      }
    })
    // let days = this.wounds.map((e, i) => `${i + 1}`);
    let woundDates = []
    woundDates = this.wounds.map(wound=> moment(wound.createdAt).format('MMM/DD/YYYY'));
    enteredDotphrases = JSON.parse(JSON.stringify(charge_phrase));
    woundDates.forEach((d, indexx)=>{
      let index = enteredDotphrases.findIndex((c)=> c?.enter_date === d);
      if(index > -1){
        enteredDotphrases.splice(index,1); 
      }
    });
    enteredDotphrases = enteredDotphrases.map((p) => p.enter_date);
    const beforeSortDates= JSON.parse(JSON.stringify([...woundDates, ...enteredDotphrases]));
    let allDates = JSON.parse(JSON.stringify(_.union(beforeSortDates)));
    console.log("Before sort", allDates);
    allDates.sort((a: string, b: string) => {
      const dateA = moment(a, 'MMM/DD/YYYY');
      const dateB = moment(b, 'MMM/DD/YYYY');

      if (dateA.isBefore(dateB)) {
        return -1;
      } else if (dateA.isAfter(dateB)) {
        return 1;
      } else {
        return 0;
      }
    });
    console.log("After sort", allDates);
    if(allDates.length > area.length){
      enteredDotphrases.forEach((date)=>{
        const dateIndex = allDates.findIndex((d)=> d === date);
        if(dateIndex > -1){
          if(dateIndex > 1){
            if(area[dateIndex - 1] === undefined || area[dateIndex - 1] === null){
              area.splice(dateIndex,0,area[area.length - 1])
              volume.splice(dateIndex,0,volume[volume.length - 1])
            }else{
              area.splice(dateIndex,0,area[dateIndex - 1])
              volume.splice(dateIndex,0,volume[dateIndex - 1])
            }
          }else{
            area.splice(dateIndex,0,area[0])
            volume.splice(dateIndex,0,volume[0])
          }
        }
      });
    }
    // dates[0] = 'Oct/25/2022';
    let pointScale = [];
    allDates.forEach((d)=>{
      let index = charge_phrase.findIndex((c)=> c?.enter_date === d); 
      if(index > -1){
        var letterImage = new Image();
        letterImage.width = 20;
        letterImage.height = 20;
        if(charge_phrase[index].key.toLowerCase().includes('debridement')){
          letterImage.src ="../../../../../../assets/icons/letterD.png";
        }else if(charge_phrase[index].key.toLowerCase().includes('biopsy')){
          letterImage.src ="../../../../../../assets/icons/letterB.png";
        }else{
          letterImage.src ="../../../../../../assets/icons/letterG.png";
        }
        pointScale.push(letterImage);
      }else{
        pointScale.push('circle')
      }
    })
    console.log({
      area,
      volume,
      allDates
    });

    this.canvas = this.lineChart.nativeElement;
    this.ctx = this.canvas.getContext('2d');
    console.log(this.chart);
    if (this.chart) {
      this.chart.destroy();
    }
    this.chart = new Chart(this.ctx, {
      type: 'line',
      data: {
        datasets: [{
          label: 'Area',
          data: area,
          backgroundColor: "rgb(115 185 243 / 65%)",
          borderColor: "green",
          pointStyle: pointScale
          // fill: true,
        },
        {
          label: 'Volume',
          data: volume,
          backgroundColor: "#47a0e8",
          borderColor: "blue",
          // fill: true,
        }],
        labels: allDates
      },
      options: {
        plugins: {
          subtitle: {
            display: true,
            color: "#FF0000",
            text: 'D=Debridement  B=Biopsy  G=Graft'
        }
        },
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }

    });
    this.allDataLoaded = true;
  }
}
